import * as React from 'react';
import Loader from 'react-loader';
import notify from '../../../../shared/feedback/notifications';
import { connect } from 'react-redux';
import {
    Tab,
    Nav,
    NavItem,
    Button,
    FormGroup,
    ButtonGroup,
    Label,
    Panel,
    Row,
    Col
} from 'react-bootstrap';
import * as Features from '../../../../shared/Features';
import * as PhotoStatus from '../../../../shared/PhotoStatus';
import * as Feature from '../../../../shared/Features';
import * as OrderTypes from '../OrderTypes';
import { checkIfOrderIsArchived } from '../../OrdersActions';
import { handleError } from '../../../../shared/ErrorCatching';
import { Translate } from '../../../../shared/LanguageService';
import { assign } from '../../../../shared/Assign';
import ConfirmationModal from '../../../../components/common/ConfirmationModal';
import ImageProcessingApi from './api/ImageProcessingApi';
import { default as ImageProcessingModal } from './modal/ImageProcessingModal';
import { ImageType, CommentType, IImageThumbnail } from './Entities';
import * as actions from './actions/ImageProcessingActions';
import EditedImagesPage from './EditedImagesPage';
import UneditedImagesPage from './UneditedImagesPage';
import ImageProcessingStatusActions from './ImageProcessingStatusActions';
import ImageProcessingDelivery from './ImageProcessingDelivery';
import ImageProcessingDeliveryOptions from './ImageProcessingDeliveryOptions';
import * as ArchiveStatus from '../../../../shared/ArchiveStatus';
import { selectArchivedInfo } from '../../../../store/selectors/OrderSelectors.store';
import AutoResizeTextArea from './AutoResizeTextArea';
import { createCostWithCurrency } from '../../../../shared/localization/currency';

const N_KEY = 78;
const CTRL_KEY = 17;

export class ImageProcessingPage extends React.Component<any, any> {
    private _hasSetImageTab: boolean = false;
    private imageProcessingCommentsLoaded: boolean = false;

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showImages: false,
            showModal: false,
            showResetDeliveryConfirmationModal: false,
            showGetImagesButton: false,
            modal: {
                imageId: 0,
                imageType: 0,
                idList: []
            },
            imageTabKey: Features.hasFeature(Features.ViewUneditedImages, this.props.user) ? 1 : 2,

            allowStitching: false,

            imageProcessingComments: {
                deliveryWarning: '',
                originalDeliveryWarning: '',
                toEditorFromChainComment: '',
                toEditorFromFrimComment: '',
                originalToEditorFromChainComment: '',
                originalToEditorFromFirmComment: '',
                fromEditorComment: '',
                originalFromEditorComment: '',
                toPhotographerComment: '',
                originalToPhotographerComment: '',
                fromAgentToPhotographerComment: '',
                originalFromAgentToPhotographerComment: '',
                internalComment: '',
                originalInternalComment: '',
                fromPhotographerComment: '',
                originalFromPhotographerComment: '',
                fromPhotographerToEditorComment:
                    'AMOUNT Number of images after editing: Normal[__] Extra [__]',
                originalFromPhotographerToEditorComment: '',
                editToEditorFromChainComment: false,
                editToEditorFromFirmComment: false,
                editFromEditorComment: false,
                editCommentsToPhotographer: false,
                editCommentsFromPhotographer: false,
                editCommentsFromPhotographerToEditor: false,
                editInternalComment: false,
                editDeliveryWarning: false
            },

            ctrlIsDown: false,
            showCompareImages: false,
            selectedImages: {
                edited: [],
                unedited: []
            },
            isWriting: false
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.showModalForImage = this.showModalForImage.bind(this);
        this.showImages = this.showImages.bind(this);
        this.onImageTabChanged = this.onImageTabChanged.bind(this);
        this.onChange = this.onChange.bind(this);
        this.saveComment = this.saveComment.bind(this);
        this.openEditComment = this.openEditComment.bind(this);
        this.cancelComment = this.cancelComment.bind(this);
        this.doneEditingImages = this.doneEditingImages.bind(this);
        this.approveBySe360 = this.approveBySe360.bind(this);
        this.approveByCustomer = this.approveByCustomer.bind(this);
        this.reapproveByCustomer = this.reapproveByCustomer.bind(this);
        this.reDeliverImages = this.reDeliverImages.bind(this);
        this.canPhotographerApprove = this.canPhotographerApprove.bind(this);
        this.approveByPhotographer = this.approveByPhotographer.bind(this);
        this.isEditorUploadDoneEnabled = this.isEditorUploadDoneEnabled.bind(this);
        this.canViewUneditedImagesTab = this.canViewUneditedImagesTab.bind(this);
        this.loadData = this.loadData.bind(this);
        this.canViewEditedImagesTab = this.canViewEditedImagesTab.bind(this);
        this.resetDelivery = this.resetDelivery.bind(this);
        this.resetRejection = this.resetRejection.bind(this);
        this.showResetDeliveryConfirmationModal =
            this.showResetDeliveryConfirmationModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.setSelectedImages = this.setSelectedImages.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (!this.imageProcessingCommentsLoaded && nextProps.imageProcessingComments) {
            this.imageProcessingCommentsLoaded = true;
            let imageProcessingComments = assign({}, nextProps.imageProcessingComments);
            imageProcessingComments.originalToEditorFromChainComment =
                nextProps.imageProcessingComments.toEditorFromChainComment;
            imageProcessingComments.originalToEditorFromFrimComment =
                nextProps.imageProcessingComments.toEditorFromFirmComment;                
            imageProcessingComments.originalFromEditorComment =
                nextProps.imageProcessingComments.fromEditorComment;
            imageProcessingComments.originalToPhotographerComment =
                nextProps.imageProcessingComments.toPhotographerComment;
            imageProcessingComments.originalFromAgentToPhotographerComment =
                nextProps.imageProcessingComments.fromAgentToPhotographerComment;
            imageProcessingComments.originalFromPhotographerComment =
                nextProps.imageProcessingComments.fromPhotographerComment;
            imageProcessingComments.originalInternalComment =
                nextProps.imageProcessingComments.internalComment;
            imageProcessingComments.originalDeliveryWarning =
                nextProps.imageProcessingComments.deliveryWarning;

            /* Keep amount comment */
            if (
                nextProps.imageProcessingComments.fromPhotographerToEditorComment &&
                nextProps.imageProcessingComments.fromPhotographerToEditorComment.length > 0
            ) {
                imageProcessingComments.originalFromPhotographerToEditorComment =
                    nextProps.imageProcessingComments.fromPhotographerToEditorComment;
            } else {
                imageProcessingComments.originalFromPhotographerToEditorComment =
                    this.state.imageProcessingComments.fromPhotographerToEditorComment;
                imageProcessingComments.fromPhotographerToEditorComment =
                    this.state.imageProcessingComments.fromPhotographerToEditorComment;
            }

            this.setState({ imageProcessingComments: imageProcessingComments });
        }

        this.setState({
            allowStitching: nextProps.allowStitchingOfEditingImages
        });

        if (
            !this._hasSetImageTab &&
            nextProps.numberOfImages &&
            nextProps.photoStatus.hasEditCustomerImages !== undefined &&
            nextProps.photoStatus.photographerIsEditor !== undefined
        ) {
            if (
                (nextProps.numberOfImages.edited !== undefined &&
                    nextProps.numberOfImages.edited > 0) ||
                nextProps.photoStatus.photographerIsEditor
            ) {
                this.setState({ imageTabKey: 2 });
            } else if (
                Features.hasFeature(Features.EditCustomerImages, this.props.user) &&
                nextProps.photoStatus.hasEditCustomerImages
            ) {
                this.setState({ imageTabKey: 1 });
            }

            this._hasSetImageTab = true;
        }

        if (
            nextProps.orderId !== this.props.orderId &&
            (nextProps.orderType & OrderTypes.photo) !== 0
        ) {
            this.props.actions.setCurrentOrder(nextProps.orderId);
            this.loadData(nextProps.orderId);
        }
    }

    componentDidMount() {
        this.props.actions.setCurrentOrder(this.props.orderId);
        this.registerKeyEvent();
        this.props.actions
            .checkIfOrderIsArchived(this.props.orderId)
            .then(() => {
                if (
                    (!this.props.archivedInfo.photoIsArchived &&
                        !this.props.archivedInfo.photoIsPreArchived) ||
                    this.props.archivedStatus < ArchiveStatus.ArchivedCold
                ) {
                    this.loadData(this.props.orderId);
                }

                if (
                    this.props.archivedInfo.photoIsPreArchived &&
                    this.props.archivedInfo.archivedStatus < ArchiveStatus.ArchivedGlacier
                ) {
                    this.setState({ showGetImagesButton: true });
                }
            })
            .catch((error: any) => handleError(error));
    }

    loadData(orderId) {
        this.setState({ showImages: true });

        this.props.actions
            .getImageProcessingInfo(orderId)
            .catch((error: any) => handleError(error));

        this.props.actions.getPhotoStatus(orderId).catch((error: any) => handleError(error));

        if (Feature.hasFeature(Feature.ResetContentProviderDelivery, this.props.user)) {
            this.props.actions
                .getContentProvider(orderId)
                .catch((error: any) => handleError(error));
        }

        this.props.actions
            .getVitecBrokerSystemDeliveryInfo(orderId)
            .catch((error: any) => handleError(error));
    }

    showImages() {
        this.loadData(this.props.orderId);
    }

    componentWillUnmount() {
        this.props.actions.clearState();
        this.unregisterKeyEvent();
    }

    showModalForImage(id: number, imageType: number, idList: number[], canDelete: boolean) {
        this.setState({
            modal: {
                imageId: id,
                imageType: imageType,
                idList: idList,
                canDelete: canDelete
            }
        });
        this.toggleModal();
    }

    toggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    onChange(e: any) {
        let imageProcessingComments = this.state.imageProcessingComments;
        if (e.target.name.startsWith('imageProcessingComments.')) {
            imageProcessingComments[e.target.name.replace('imageProcessingComments.', '')] =
                e.target.value;
            this.setState({ imageProcessingComments: imageProcessingComments });
        }
    }

    onImageTabChanged(key: any) {
        this.setState({ imageTabKey: key });

        if (key === 1) {
            this.props.actions.listImages(this.props.orderId, ImageType.UNEDITED);
        } else if (key === 2) {
            this.props.actions.listImages(this.props.orderId, ImageType.EDITED);
        }
    }

    cancelComment(type: number) {
        this.setState({ isWriting: false });
        let imageProcessingComments = this.state.imageProcessingComments;
        switch (type) {
            case CommentType.TO_IMAGE_EDITOR_FROM_CHAIN:
                imageProcessingComments.editToEditorFromChainComment = false;
                imageProcessingComments.toEditorFromChainComment =
                    imageProcessingComments.originalToEditorFromChainComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.TO_IMAGE_EDITOR_FROM_FIRM:
                imageProcessingComments.editToEditorFromFirmComment = false;
                imageProcessingComments.toEditorFromFirmComment =
                    imageProcessingComments.originalToEditorFromFirmComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_IMAGE_EDITOR:
                imageProcessingComments.editFromEditorComment = false;
                imageProcessingComments.fromEditorComment =
                    imageProcessingComments.originalFromEditorComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.TO_PHOTOGRAPHER:
                imageProcessingComments.editToPhotographerComment = false;
                imageProcessingComments.toPhotographerComment =
                    imageProcessingComments.originalToPhotographerComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_AGENT_TO_PHOTOGRAPHER:
                imageProcessingComments.editFromAgentToPhotographerComment = false;
                imageProcessingComments.fromAgentToPhotographerComment =
                    imageProcessingComments.originalFromAgentToPhotographerComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.INTERNAL:
                imageProcessingComments.editInternalComment = false;
                imageProcessingComments.internalComment =
                    imageProcessingComments.originalInternalComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_PHOTOGRAPHER:
                imageProcessingComments.editFromPhotographerComment = false;
                imageProcessingComments.fromPhotographerComment =
                    imageProcessingComments.originalFromPhotographerComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_PHOTOGRAPHER_TO_EDITOR:
                imageProcessingComments.editFromPhotographerToEditorComment = false;
                imageProcessingComments.fromPhotographerToEditorComment =
                    imageProcessingComments.originalFromPhotographerToEditorComment;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.DELIVERY_WARNING:
                imageProcessingComments.editDeliveryWarning = false;
                imageProcessingComments.deliveryWarning =
                    imageProcessingComments.originalDeliveryWarning;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            default:
                break;
        }
    }

    saveComment(text: string, type: number) {
        this.setState({ isWriting: false });
        this.props.actions
            .updateImageProcessingComment(this.props.orderId, text.trim(), type)
            .then(() => {
                notify.success(Translate('image-processing/notification/comment-updated'));
                let imageProcessingComments = this.state.imageProcessingComments;
                imageProcessingComments.originalToEditorFromChainComment =
                    imageProcessingComments.toEditorFromChainComment;
                imageProcessingComments.originalToEditorFromFirmComment =
                    imageProcessingComments.toEditorFromFirmComment;
                imageProcessingComments.originalFromEditorComment =
                    imageProcessingComments.fromEditorComment;
                imageProcessingComments.originalToPhotographerComment =
                    imageProcessingComments.toPhotographerComment;
                imageProcessingComments.originalFromAgentToPhotographerComment =
                    imageProcessingComments.fromAgentToPhotographerComment;
                imageProcessingComments.originalInternalComment =
                    imageProcessingComments.internalComment;
                imageProcessingComments.originalFromPhotographerComment =
                    imageProcessingComments.fromPhotographerComment;
                imageProcessingComments.originalFromPhotographerToEditorComment =
                    imageProcessingComments.fromPhotographerToEditorComment;
                switch (type) {
                    case CommentType.TO_IMAGE_EDITOR_FROM_CHAIN:
                        imageProcessingComments.editToEditorFromChainComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.TO_IMAGE_EDITOR_FROM_FIRM:
                        imageProcessingComments.editToEditorFromFirmComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;                        
                    case CommentType.FROM_IMAGE_EDITOR:
                        imageProcessingComments.editFromEditorComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.TO_PHOTOGRAPHER:
                        imageProcessingComments.editToPhotographerComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.FROM_AGENT_TO_PHOTOGRAPHER:
                        imageProcessingComments.editFromAgentToPhotographerComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.INTERNAL:
                        imageProcessingComments.editInternalComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.FROM_PHOTOGRAPHER:
                        imageProcessingComments.editFromPhotographerComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.FROM_PHOTOGRAPHER_TO_EDITOR:
                        imageProcessingComments.editFromPhotographerToEditorComment = false;
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    case CommentType.DELIVERY_WARNING:
                        imageProcessingComments.editDeliveryWarning = false;
                        imageProcessingComments.deliveryWarning = imageProcessingComments.deliveryWarning.trim();
                        this.setState({
                            imageProcessingComments: imageProcessingComments
                        });
                        break;
                    default:
                        break;
                }
            })
            .catch((error: string) => handleError(error));
    }

    openEditComment(commentType: number) {
        this.setState({ isWriting: true });
        let imageProcessingComments = this.state.imageProcessingComments;
        switch (commentType) {
            case CommentType.TO_IMAGE_EDITOR_FROM_CHAIN:
                imageProcessingComments.editToEditorFromChainComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.TO_IMAGE_EDITOR_FROM_FIRM:
                imageProcessingComments.editToEditorFromFirmComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_IMAGE_EDITOR:
                imageProcessingComments.editFromEditorComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.TO_PHOTOGRAPHER:
                imageProcessingComments.editToPhotographerComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_AGENT_TO_PHOTOGRAPHER:
                imageProcessingComments.editFromAgentToPhotographerComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.INTERNAL:
                imageProcessingComments.editInternalComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_PHOTOGRAPHER:
                imageProcessingComments.editFromPhotographerComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.FROM_PHOTOGRAPHER_TO_EDITOR:
                imageProcessingComments.editFromPhotographerToEditorComment = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            case CommentType.DELIVERY_WARNING:
                imageProcessingComments.editDeliveryWarning = true;
                this.setState({
                    imageProcessingComments: imageProcessingComments
                });
                break;
            default:
                break;
        }
    }

    doneEditingImages(): void {
        this.props.actions
            .doneEditingImages(this.props.orderId)
            .then(() =>
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                )
            )
            .catch((error: any) => handleError(error));

        if (Features.hasFeature(Features.ApproveImagesBySE360, this.props.user)) {
            this.props.actions.getDeliveryStatusForOrder(this.props.orderId);
        }
    }

    approveBySe360() {
        this.props.actions
            .approveBySe360(this.props.orderId)
            .then(() =>
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                )
            )
            .catch((error: any) => handleError(error));
    }

    approveByCustomer(): void {
        this.setState({ allowStitching: false, loading: true });

        this.props.actions
            .approveByCustomer(this.props.orderId)
            .then(() => {
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                );
                this.setState({ loading: false });
            })
            .catch((error: any) => handleError(error));
    }

    reapproveByCustomer(): void {
        this.setState({ allowStitching: false });

        this.props.actions
            .reapproveByCustomer(this.props.orderId)
            .then(() =>
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                )
            )
            .catch((error: any) => handleError(error));
    }

    approveByPhotographer(): void {
        this.props.actions
            .approveByPhotographer(this.props.orderId)
            .then(() => {
                this.props.actions.listImages(this.props.orderId, ImageType.EDITED);
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                );
                this.props.reloadData();
            })
            .catch((error: any) => handleError(error));
    }

    handleRetrieveOrder = async () => {
        let { orderId } = this.props;

        try {
            await ImageProcessingApi.retrieveOrderAsPhotographer(orderId);
            this.loadData(orderId);
            notify.success(
                Translate('image-processing/page/status-actions/photographer-retrieved-order')
            );
        } catch (error) {
            handleError(error);
        }
    };

    canPhotographerApprove(): boolean {
        return this.props.anyFailedUploadedImages === false;
    }

    reDeliverImages(): void {
        this.props.actions
            .reDeliverImages(this.props.orderId)
            .then(() =>
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                )
            )
            .catch((error: any) => handleError(error));
    }

    resetRejection(): void {
        this.props.actions
            .resetRejection(this.props.orderId)
            .then(() => {
                notify.success(
                    Translate('image-processing/page/status-actions/notification/success')
                );
                this.props.actions.listImages(
                    this.props.orderId,
                    this.state.imageTabKey === 2 ? ImageType.EDITED : ImageType.UNEDITED
                );
            })
            .catch((error: any) => handleError(error));
    }

    resetDelivery(): void {
        this.props.actions
            .resetDelivery(this.props.orderId)
            .then((result: string) => notify.success(Translate(result)))
            .catch((error: any) => handleError(error));
    }

    showResetDeliveryConfirmationModal(): void {
        this.setState({ showResetDeliveryConfirmationModal: true });
    }

    isEditorUploadDoneEnabled(): boolean {
        let hasUploadedAllNormalImages = true;
        if (
            this.props.photoStatus.normalImageSizeSettings &&
            this.props.photoStatus.normalImageSizeSettings.autoScale === false
        ) {
            hasUploadedAllNormalImages = this.props.editedList.every((x) => {
                return x.thumbnails
                    .filter((y) => y.categoryId !== 3 /* Ej Lev */)
                    .every((y) => {
                        return y.hasUploadedNormal === true;
                    });
            });
        }

        return (
            hasUploadedAllNormalImages &&
            (this.props.photoStatus.currentStatus === PhotoStatus.EditorUploading ||
                (this.props.numberOfImages &&
                    this.props.numberOfImages.edited > 0 &&
                    this.props.photoStatus.currentStatus === PhotoStatus.UploaderApproved)) &&
            (Feature.hasFeature(Feature.DoneEditingImages, this.props.user) ||
                (Feature.hasFeature(
                    Feature.HandleEditedImagesWhenPhotographerIsEditor,
                    this.props.user
                ) &&
                    this.props.photoStatus.photographerIsEditor))
        );
    }

    canViewUneditedImagesTab() {
        return (
            (Features.hasFeature(Features.ViewUneditedImages, this.props.user) ||
                (Features.hasFeature(Features.EditCustomerImages, this.props.user) &&
                    this.props.photoStatus.hasEditCustomerImages)) &&
            this.props.photoStatus.photographerIsEditor === false
        );
    }

    canViewEditedImagesTab() {
        return (
            Features.hasFeature(Features.ViewEditedImages, this.props.user) ||
            (Features.hasFeature(Features.ViewDeliveredEditedImages, this.props.user) &&
                (this.props.photoStatus.currentStatus === PhotoStatus.Se360Approved ||
                    this.props.photoStatus.currentStatus === PhotoStatus.CustomerApproved ||
                    this.props.photoStatus.currentStatus === PhotoStatus.ScheduledForCustomerApproval ||
                    this.props.photoStatus.currentStatus === PhotoStatus.DeliveryStarted ||
                    this.props.photoStatus.currentStatus === PhotoStatus.Delivered ||
                    this.props.photoStatus.currentStatus === PhotoStatus.DeliveryError ||
                    this.props.photoStatus.currentStatus === PhotoStatus.SetToRedeliver))
        );
    }

    registerKeyEvent() {
        document.addEventListener('keyup', this.onKeyUp);
        document.addEventListener('keydown', this.onKeyDown);
    }

    unregisterKeyEvent() {
        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyUp(e: any) {
        if (e.keyCode === CTRL_KEY) {
            this.setState({ ctrlIsDown: false });
        }
    }

    onKeyDown(e: any) {
        if (e.keyCode === N_KEY && !this.state.isWriting) {
            if (
                (this.state.selectedImages.unedited.length > 0 && this.state.imageTabKey === 1) ||
                (this.state.selectedImages.edited.length > 0 && this.state.imageTabKey === 2)
            ) {
                this.setState({ showCompareImages: true });
            }
        } else if (e.keyCode === CTRL_KEY) {
            this.setState({ ctrlIsDown: true });
        }
    }

    setSelectedImages(images: number[], tabKey: number) {
        if (tabKey === 1) {
            this.setState({
                selectedImages: {
                    unedited: this.state.selectedImages.unedited,
                    edited: images
                }
            });
        } else if (tabKey === 2) {
            this.setState({
                selectedImages: {
                    unedited: images,
                    edited: this.state.selectedImages.edited
                }
            });
        }
    }

    render() {
        const options = {
            position: 'relative',
            paddingTop: 20,
            paddingBottom: 30
        };

        let orderNeedsConfirmation: boolean = false;

        for (var i = 0; i < this.props.orderRows.length; i++) {
            let thumbnails: IImageThumbnail[] = this.props.orderRows[i].thumbnails.filter(
                (img: IImageThumbnail) => {
                    return (
                        img.overrideProperties &&
                        img.overrideProperties.categoryId !== img.categoryId
                    );
                }
            );
            if (thumbnails.length > 0) {
                orderNeedsConfirmation = true;
                break;
            }
        }

        if (this.state.loading) {
            return (
                <div
                    className="progressbar-inline"
                    style={{
                        position: 'relative',
                        paddingBottom: 30
                    }}
                >
                    <Loader loaded={false} options={options} className="spinner"></Loader>
                </div>
            );
        }

        let extraImageCost = null;
        let { editedList } = this.props;
        if (editedList.length > 0) {
            let _extraImageCost = editedList[0].extraImageCost;
            if (_extraImageCost) {
                extraImageCost = createCostWithCurrency(
                    _extraImageCost.value,
                    _extraImageCost.currency
                );
            }
        }

        const { 
            chainDeliveryWarning, 
            firmDeliveryWarning, 
            deliveryWarning, 
            editDeliveryWarning 
        } = this.state.imageProcessingComments;

        const deliveryWarningNotEmpty = 
            chainDeliveryWarning ||
            firmDeliveryWarning ||
            deliveryWarning ||
            editDeliveryWarning;
            
        return (
            <div>
                {!this.canViewEditedImagesTab() &&
                    Translate('image-processing/page/under-production')}
                <Row>
                    <Col sm={6}>
                        {this.state.imageProcessingComments &&
                            Features.hasAnyFeature(
                                [
                                    Features.ViewImageEditorComments,
                                    Features.ViewInformationToPhotographer
                                ],
                                this.props.user
                            ) && (
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title>
                                            {this.getCommentHeader(CommentType.FROM_IMAGE_EDITOR)}
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        {!this.state.imageProcessingComments
                                            .editFromEditorComment &&
                                            this.state.imageProcessingComments.fromEditorComment}
                                        {!this.state.imageProcessingComments
                                            .editFromEditorComment &&
                                            !this.state.imageProcessingComments
                                                .fromEditorComment && <span></span>}
                                        {this.state.imageProcessingComments
                                            .editFromEditorComment && (
                                            <div>
                                                <FormGroup>
                                                    <AutoResizeTextArea
                                                        name="imageProcessingComments.fromEditorComment"
                                                        value={
                                                            this.state.imageProcessingComments
                                                                .fromEditorComment
                                                        }
                                                        maxHeightPx={300}
                                                        onChange={this.onChange}
                                                    />
                                                </FormGroup>
                                                <ButtonGroup className="pull-right">
                                                    <Button
                                                        onClick={() =>
                                                            this.cancelComment(
                                                                CommentType.FROM_IMAGE_EDITOR
                                                            )
                                                        }
                                                    >
                                                        {Translate(
                                                            'image-processing/page/comment/button-label/cancel'
                                                        )}
                                                    </Button>
                                                    <Button
                                                        bsStyle="primary"
                                                        onClick={() =>
                                                            this.saveComment(
                                                                this.state.imageProcessingComments
                                                                    .fromEditorComment,
                                                                CommentType.FROM_IMAGE_EDITOR
                                                            )
                                                        }
                                                    >
                                                        {Translate(
                                                            'image-processing/page/comment/button-label/save'
                                                        )}
                                                    </Button>
                                                </ButtonGroup>
                                            </div>
                                        )}
                                    </Panel.Body>
                                </Panel>
                            )}

                        {Feature.hasFeature(Feature.ViewInformationForSe360, this.props.user) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(CommentType.INTERNAL)}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments.editInternalComment &&
                                        this.state.imageProcessingComments.internalComment}
                                    {!this.state.imageProcessingComments.editInternalComment &&
                                        !this.state.imageProcessingComments.internalComment && (
                                            <span></span>
                                        )}
                                    {this.state.imageProcessingComments.editInternalComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.internalComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .internalComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(CommentType.INTERNAL)
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .internalComment,
                                                            CommentType.INTERNAL
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {Feature.hasFeature(
                            Feature.ViewInformationToPhotographer,
                            this.props.user
                        ) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(CommentType.TO_PHOTOGRAPHER)}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments
                                        .editToPhotographerComment &&
                                        this.state.imageProcessingComments.toPhotographerComment}
                                    {!this.state.imageProcessingComments
                                        .editToPhotographerComment &&
                                        !this.state.imageProcessingComments
                                            .toPhotographerComment && <span></span>}
                                    {this.state.imageProcessingComments
                                        .editToPhotographerComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.toPhotographerComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .toPhotographerComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.TO_PHOTOGRAPHER
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .toPhotographerComment,
                                                            CommentType.TO_PHOTOGRAPHER
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {Feature.hasFeature(
                            Feature.ViewInformationToPhotographer,
                            this.props.user
                        ) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(
                                            CommentType.FROM_AGENT_TO_PHOTOGRAPHER
                                        )}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments
                                        .editFromAgentToPhotographerComment &&
                                        this.state.imageProcessingComments
                                            .fromAgentToPhotographerComment}
                                    {!this.state.imageProcessingComments
                                        .editFromAgentToPhotographerComment &&
                                        !this.state.imageProcessingComments
                                            .fromAgentToPhotographerComment && <span></span>}
                                    {this.state.imageProcessingComments
                                        .editFromAgentToPhotographerComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.fromAgentToPhotographerComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .fromAgentToPhotographerComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.FROM_AGENT_TO_PHOTOGRAPHER
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .fromAgentToPhotographerComment,
                                                            CommentType.FROM_AGENT_TO_PHOTOGRAPHER
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {Feature.hasFeature(
                            Feature.ViewInformationToPhotographer,
                            this.props.user
                        ) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(CommentType.FROM_PHOTOGRAPHER)}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments
                                        .editFromPhotographerComment &&
                                        this.state.imageProcessingComments.fromPhotographerComment}
                                    {!this.state.imageProcessingComments
                                        .editFromPhotographerComment &&
                                        !this.state.imageProcessingComments
                                            .fromPhotographerComment && <span></span>}
                                    {this.state.imageProcessingComments
                                        .editFromPhotographerComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.fromPhotographerComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .fromPhotographerComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.FROM_PHOTOGRAPHER
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .fromPhotographerComment,
                                                            CommentType.FROM_PHOTOGRAPHER
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {(Feature.hasFeature(
                            Feature.ViewInformationToImageEditor,
                            this.props.user
                        ) ||
                            Feature.hasFeature(
                                Feature.UpdateCommentFromPhotographer,
                                this.props.user
                            )) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(
                                            CommentType.FROM_PHOTOGRAPHER_TO_EDITOR
                                        )}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments
                                        .editFromPhotographerToEditorComment &&
                                        this.state.imageProcessingComments
                                            .fromPhotographerToEditorComment}
                                    {!this.state.imageProcessingComments
                                        .editFromPhotographerToEditorComment &&
                                        !this.state.imageProcessingComments
                                            .fromPhotographerToEditorComment && <span></span>}
                                    {this.state.imageProcessingComments
                                        .editFromPhotographerToEditorComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.fromPhotographerToEditorComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .fromPhotographerToEditorComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.FROM_PHOTOGRAPHER_TO_EDITOR
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .fromPhotographerToEditorComment,
                                                            CommentType.FROM_PHOTOGRAPHER_TO_EDITOR
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}
                    </Col>
                    <Col sm={6}>
                        {Features.hasFeature(Features.ViewInformationForSe360, this.props.user) && (
                            <Panel defaultExpanded>
                                <Panel.Heading>
                                    <Panel.Title toggle>
                                        <div>
                                            {Translate(
                                                'image-processing/page/panel-header/chain-internal-information'
                                            )}
                                        </div>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Collapse>
                                    <Panel.Body>
                                        {
                                            this.state.imageProcessingComments
                                                .chainInternalInformation
                                        }
                                    </Panel.Body>
                                </Panel.Collapse>
                            </Panel>
                        )}

                        {Features.hasFeature(Features.ViewInformationForSe360, this.props.user) && (
                            <Panel defaultExpanded>
                                <Panel.Heading>
                                    <Panel.Title toggle>
                                        <div>
                                            {Translate(
                                                'image-processing/page/panel-header/firm-internal-information'
                                            )}
                                        </div>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Collapse>
                                    <Panel.Body>
                                        {this.state.imageProcessingComments.firmInternalInformation}
                                    </Panel.Body>
                                </Panel.Collapse>
                            </Panel>
                        )}

                        {Features.hasFeature(
                            Features.ViewInformationToPhotographer,
                            this.props.user
                        ) && (
                            <div>
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title>
                                            {
                                                <div>
                                                    {Translate(
                                                        'image-processing/page/panel-header/chain-photographer-information'
                                                    )}
                                                </div>
                                            }
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        {
                                            this.state.imageProcessingComments
                                                .chainPhotographerInformation
                                        }
                                    </Panel.Body>
                                </Panel>
                                <Panel>
                                    <Panel.Heading>
                                        <Panel.Title>
                                            {
                                                <div>
                                                    {Translate(
                                                        'image-processing/page/panel-header/firm-photographer-information'
                                                    )}
                                                </div>
                                            }
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        {
                                            this.state.imageProcessingComments
                                                .firmPhotographerInformation
                                        }
                                    </Panel.Body>
                                </Panel>
                            </div>
                        )}

                        {Features.hasFeature(
                            Features.ViewInformationToImageEditor,
                            this.props.user
                        ) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(
                                            CommentType.TO_IMAGE_EDITOR_FROM_CHAIN
                                        )}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments
                                        .editToEditorFromChainComment &&
                                        this.state.imageProcessingComments.toEditorFromChainComment}
                                    {!this.state.imageProcessingComments
                                        .editToEditorFromChainComment &&
                                        !this.state.imageProcessingComments
                                            .toEditorFromChainComment && <span></span>}
                                    {this.state.imageProcessingComments
                                        .editToEditorFromChainComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.toEditorFromChainComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .toEditorFromChainComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.TO_IMAGE_EDITOR_FROM_CHAIN
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .toEditorFromChainComment,
                                                            CommentType.TO_IMAGE_EDITOR_FROM_CHAIN
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {Features.hasFeature(
                            Features.ViewInformationToImageEditor,
                            this.props.user
                        ) && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(
                                            CommentType.TO_IMAGE_EDITOR_FROM_FIRM
                                        )}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {!this.state.imageProcessingComments
                                        .editToEditorFromFirmComment &&
                                        this.state.imageProcessingComments.toEditorFromFirmComment}
                                    {!this.state.imageProcessingComments
                                        .editToEditorFromFirmComment &&
                                        !this.state.imageProcessingComments
                                            .toEditorFromFirmComment && <span></span>}
                                    {this.state.imageProcessingComments
                                        .editToEditorFromFirmComment && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.toEditorFromFirmComment"
                                                    value={
                                                        this.state.imageProcessingComments
                                                            .toEditorFromFirmComment
                                                    }
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.TO_IMAGE_EDITOR_FROM_FIRM
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            this.state.imageProcessingComments
                                                                .toEditorFromFirmComment,
                                                            CommentType.TO_IMAGE_EDITOR_FROM_FIRM
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {Features.hasFeature(Features.ViewInformationForSe360, this.props.user) && (
                            <Panel bsStyle={deliveryWarningNotEmpty ? 'warning' : 'default'}>
                                <Panel.Heading>
                                    <Panel.Title>
                                        {this.getCommentHeader(CommentType.DELIVERY_WARNING)}
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {chainDeliveryWarning && <span>{chainDeliveryWarning}</span>}
                                    {chainDeliveryWarning && firmDeliveryWarning && (
                                        <hr style={{ marginTop: '8px', marginBottom: '8px' }} />
                                    )}
                                    {firmDeliveryWarning && <span>{firmDeliveryWarning}</span>}
                                    {(firmDeliveryWarning || chainDeliveryWarning) &&
                                        deliveryWarning && (
                                            <hr style={{ marginTop: '8px', marginBottom: '8px' }} />
                                        )}
                                    {!editDeliveryWarning && deliveryWarning && (
                                        <span>{deliveryWarning}</span>
                                    )}
                                    {editDeliveryWarning && (
                                        <div>
                                            <FormGroup>
                                                <AutoResizeTextArea
                                                    name="imageProcessingComments.deliveryWarning"
                                                    value={deliveryWarning}
                                                    maxHeightPx={300}
                                                    onChange={this.onChange}
                                                />
                                            </FormGroup>
                                            <ButtonGroup className="pull-right">
                                                <Button
                                                    onClick={() =>
                                                        this.cancelComment(
                                                            CommentType.DELIVERY_WARNING
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/cancel'
                                                    )}
                                                </Button>
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() =>
                                                        this.saveComment(
                                                            deliveryWarning,
                                                            CommentType.DELIVERY_WARNING
                                                        )
                                                    }
                                                >
                                                    {Translate(
                                                        'image-processing/page/comment/button-label/save'
                                                    )}
                                                </Button>
                                            </ButtonGroup>
                                        </div>
                                    )}
                                </Panel.Body>
                            </Panel>
                        )}

                        {this.props.photoStatus && (
                            <ImageProcessingStatusActions
                                contentProvider={this.props.contentProvider}
                                contentProviderValue={this.props.contentProviderValue}
                                photoStatus={this.props.photoStatus}
                                orderId={this.props.orderId}
                                orderApiUrl={this.props.orderApiUrl}
                                user={this.props.user}
                                isEditorUploadDoneEnabled={this.isEditorUploadDoneEnabled}
                                doneEditingImages={this.doneEditingImages}
                                canPhotographerApprove={this.canPhotographerApprove}
                                approveByPhotographer={this.approveByPhotographer}
                                approveByCustomer={this.approveByCustomer}
                                reapproveByCustomer={this.reapproveByCustomer}
                                reDeliver={this.reDeliverImages}
                                showResetDeliveryConfirmationModal={
                                    this.showResetDeliveryConfirmationModal
                                }
                                resetRejection={this.resetRejection}
                                orderNeedsConfirmation={orderNeedsConfirmation}
                                extraImages={this.props.extraImages}
                                onRetrieveOrder={this.handleRetrieveOrder}
                                extraImageCost={extraImageCost}
                            />
                        )}

                        {this.props.photoStatus &&
                            Features.hasFeature(Features.ApproveImagesBySE360, this.props.user) && (
                                <ImageProcessingDelivery
                                    orderId={this.props.orderId}
                                    photoStatus={this.props.photoStatus.currentStatus}
                                />
                            )}

                        {!this.state.showImages && this.state.showGetImagesButton && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        <div>
                                            {Translate(
                                                'image-processing/page/panel-header/show-images'
                                            )}
                                        </div>
                                    </Panel.Title>
                                </Panel.Heading>

                                <Panel.Body className="info-blue">
                                    <div>
                                        {Translate(
                                            'image-processing/page/status-actions/header/show-images/text'
                                        )}
                                        <br />
                                        <Button bsStyle="success" onClick={this.showImages}>
                                            {Translate(
                                                'image-processing/page/status-actions/button-label/retrieve-images'
                                            )}
                                        </Button>
                                    </div>
                                </Panel.Body>
                            </Panel>
                        )}

                        {this.state.imageProcessingComments.editingStyle && (
                            <Panel>
                                <Panel.Heading>
                                    <Panel.Title>
                                        <div>
                                            {Translate(
                                                'image-processing/page/panel-header/editing-style'
                                            )}
                                        </div>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {this.state.imageProcessingComments.editingStyle}
                                </Panel.Body>
                            </Panel>
                        )}
                    </Col>
                    <Col
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginBottom: '2rem',
                            paddingRight: '16px'
                        }}
                    >
                        {this.props.photoStatus &&
                            Features.hasFeature(
                                Features.ApproveImagesByCustomer,
                                this.props.user
                            ) && (
                                <ImageProcessingDeliveryOptions
                                    user={this.props.user}
                                    orderId={this.props.orderId}
                                    normalImagesAvailable={
                                        this.props.photoStatus.normalImagesAvailable
                                    }
                                    photoStatus={this.props.photoStatus.currentStatus}
                                    site={this.props.site}
                                />
                            )}
                    </Col>
                </Row>

                {!this.props.isArchived && this.state.showImages && (
                    <Tab.Container
                        activeKey={this.state.imageTabKey}
                        defaultActiveKey={1}
                        onSelect={this.onImageTabChanged}
                        id="uncontrolled-tab"
                    >
                        <div>
                            <Nav bsStyle="tabs">
                                {this.canViewUneditedImagesTab() && (
                                    <NavItem eventKey={1}>
                                        {Translate('image-processing/page/tab/unedited-images')}{' '}
                                        {this.props.numberOfImages && (
                                            <Label>{this.props.numberOfImages.original}</Label>
                                        )}
                                    </NavItem>
                                )}
                                {this.canViewEditedImagesTab() && (
                                    <NavItem eventKey={2}>
                                        {Translate('image-processing/page/tab/edited-images')}{' '}
                                        {this.props.numberOfImages && (
                                            <Label>{this.props.numberOfImages.edited}</Label>
                                        )}
                                    </NavItem>
                                )}
                            </Nav>
                            <Tab.Content>
                                {this.canViewUneditedImagesTab() && (
                                    <Tab.Pane eventKey={1}>
                                        <UneditedImagesPage
                                            showModalForImage={this.showModalForImage}
                                            orderId={this.props.orderId}
                                            productProperties={this.props.productProperties}
                                            allowStitching={false}
                                            ctrlIsDown={this.state.ctrlIsDown}
                                            showCompareImages={this.state.showCompareImages}
                                            setShowCompareImages={(value) =>
                                                this.setState({ showCompareImages: value })
                                            }
                                            selectedImages={this.state.selectedImages.unedited}
                                            setSelectedImages={this.setSelectedImages}
                                            setIsWriting={(value) =>
                                                this.setState({ isWriting: value })
                                            }
                                        />
                                    </Tab.Pane>
                                )}
                                {this.canViewEditedImagesTab() && (
                                    <Tab.Pane eventKey={2}>
                                        <EditedImagesPage
                                            showModalForImage={this.showModalForImage}
                                            orderId={this.props.orderId}
                                            productProperties={this.props.productProperties}
                                            allowStitching={
                                                this.state.allowStitching &&
                                                Feature.hasFeature(
                                                    Feature.CreateStitchedImage,
                                                    this.props.user
                                                )
                                            }
                                            normalImageSizeSettings={
                                                this.props.photoStatus.normalImageSizeSettings
                                            }
                                            highImageSizeSettings={
                                                this.props.photoStatus.highImageSizeSettings
                                            }
                                            ctrlIsDown={this.state.ctrlIsDown}
                                            showCompareImages={this.state.showCompareImages}
                                            setShowCompareImages={(value) =>
                                                this.setState({ showCompareImages: value })
                                            }
                                            selectedImages={this.state.selectedImages.edited}
                                            setSelectedImages={this.setSelectedImages}
                                            setIsWriting={(value) =>
                                                this.setState({ isWriting: value })
                                            }
                                        />
                                    </Tab.Pane>
                                )}
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                )}

                {this.state.showModal && (
                    <ImageProcessingModal
                        orderId={this.props.orderId}
                        toggleModal={this.toggleModal}
                        showModal={this.state.showModal}
                        imageId={this.state.modal.imageId}
                        imageType={this.state.modal.imageType}
                        idList={this.state.modal.idList}
                        photoStatus={this.props.photoStatus.currentStatus}
                    />
                )}

                {this.state.showResetDeliveryConfirmationModal && (
                    <ConfirmationModal
                        title={Translate(
                            'image-processing/page/status-actions/reset-delivery/confirmation/title'
                        )}
                        text={Translate(
                            'image-processing/page/status-actions/reset-delivery/confirmation/text'
                        )}
                        doButtonLabel={Translate(
                            'image-processing/page/status-actions/reset-delivery/confirmation/do-button'
                        )}
                        cancelButtonLabel={Translate(
                            'image-processing/page/status-actions/reset-delivery/confirmation/cancel-button'
                        )}
                        doButtonStyle="danger"
                        do={() => this.resetDelivery()}
                        closeModal={() =>
                            this.setState({
                                showResetDeliveryConfirmationModal: false
                            })
                        }
                    />
                )}
            </div>
        );
    }

    getCommentHeader(type: number) {
        if (type === CommentType.TO_IMAGE_EDITOR_FROM_CHAIN) {
            return (
                <div className="panel-comment-header">
                    <div>{Translate('image-processing/page/comments/header/to-image-editor-from-chain')}</div>
                    {Feature.hasFeature(Feature.UpdateCommentToEditor, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.TO_IMAGE_EDITOR_FROM_CHAIN)}
                        >
                            <i className="material-icons mode">edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.TO_IMAGE_EDITOR_FROM_FIRM) {
            return (
                <div className="panel-comment-header">
                    <div>{Translate('image-processing/page/comments/header/to-image-editor-from-firm')}</div>
                    {Feature.hasFeature(Feature.UpdateCommentToEditor, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.TO_IMAGE_EDITOR_FROM_FIRM)}
                        >
                            <i className="material-icons mode">edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.FROM_IMAGE_EDITOR) {
            return (
                <div className="panel-comment-header">
                    <div>
                        {Translate('image-processing/page/comments/header/from-image-editor')}
                    </div>
                    {Feature.hasFeature(Feature.UpdateCommentFromEditor, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.FROM_IMAGE_EDITOR)}
                        >
                            <i className="material-icons mode">edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );            
        } else if (type === CommentType.TO_PHOTOGRAPHER) {
            return (
                <div className="panel-comment-header">
                    <div>{Translate('image-processing/page/comments/header/to-photographer')}</div>
                    {Feature.hasFeature(Feature.UpdateCommentToPhotographer, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.TO_PHOTOGRAPHER)}
                        >
                            <i className="material-icons mode">edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.FROM_AGENT_TO_PHOTOGRAPHER) {
            return (
                <div className="panel-comment-header">
                    <div>{Translate('image-processing/page/comments/header/from-agent-to-photographer')}</div>
                    {Feature.hasFeature(Feature.UpdateCommentToPhotographer, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.FROM_AGENT_TO_PHOTOGRAPHER)}
                        >
                            <i className="material-icons mode">edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.INTERNAL) {
            return (
                <div className="panel-comment-header">
                    <div>{Translate('image-processing/page/comments/header/internal')}</div>
                    {Feature.hasFeature(Feature.UpdateCommentToPhotographer, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.INTERNAL)}
                        >
                            <i className="material-icons mode">edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.FROM_PHOTOGRAPHER) {
            return (
                <div className="panel-comment-header">
                    <div>
                        {Translate(
                            'image-processing/page/comments/header/from-photographer-to-se360'
                        )}
                    </div>
                    {Feature.hasFeature(Feature.UpdateCommentFromPhotographer, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() => this.openEditComment(CommentType.FROM_PHOTOGRAPHER)}
                        >
                            <i className="material-icons mode"> edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.FROM_PHOTOGRAPHER_TO_EDITOR) {
            return (
                <div className="panel-comment-header">
                    <div>
                        {Translate(
                            'image-processing/page/comments/header/from-photographer-to-editor'
                        )}
                    </div>
                    {Feature.hasFeature(Feature.UpdateCommentFromPhotographer, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle="info"
                            className="btn-edit"
                            onClick={() =>
                                this.openEditComment(CommentType.FROM_PHOTOGRAPHER_TO_EDITOR)
                            }
                        >
                            <i className="material-icons mode"> edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit-comment')}
                        </Button>
                    )}
                </div>
            );
        } else if (type === CommentType.DELIVERY_WARNING) {
            const { 
                chainDeliveryWarning, 
                firmDeliveryWarning, 
                deliveryWarning, 
                editDeliveryWarning 
            } = this.state.imageProcessingComments;

            const deliveryWarningNotEmpty = 
                chainDeliveryWarning ||
                firmDeliveryWarning ||
                deliveryWarning ||
                editDeliveryWarning;

            return (
                <div className="panel-comment-header">
                    <div>
                        {deliveryWarningNotEmpty && (
                            <i className="material-icons">warning</i>
                        )}
                        {' '}
                        {Translate(
                            'image-processing/page/panel-header/delivery-warning'
                        )}
                    </div>
                    {Feature.hasFeature(Feature.ApproveImagesBySE360, this.props.user) && (
                        <Button
                            bsSize="small"
                            bsStyle={deliveryWarningNotEmpty ? "warning" : "info"}
                            className="btn-edit"
                            onClick={() =>
                                this.openEditComment(CommentType.DELIVERY_WARNING)
                            }
                        >
                            <i className="material-icons mode"> edit</i>{' '}
                            {Translate('image-processing/page/comments/header/edit')}
                        </Button>
                    )}
                </div>
            );
        }
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getImageProcessingInfo: (orderId: number) =>
                dispatch(actions.getImageProcessingInfo(orderId)),
            updateImageProcessingComment: (orderId: number, text: string, type: number) =>
                dispatch(actions.updateImageProcessingComment(orderId, text, type)),
            setCurrentOrder: (orderId: number) => dispatch(actions.setCurrentOrder(orderId)),
            getPhotoStatus: (orderId: number) => dispatch(actions.getPhotoStatus(orderId)),
            doneEditingImages: (orderId: number) => dispatch(actions.doneEditingImages(orderId)),

            approveByCustomer: (orderId: number) =>
                dispatch(actions.customerApproveImages(orderId)),
            reapproveByCustomer: (orderId: number) =>
                dispatch(actions.customerReapproveImages(orderId)),

            approveByPhotographer: (orderId: number) =>
                dispatch(actions.photographerApprovePhotoOrder(orderId)),
            checkIfOrderIsArchived: (orderId: number) => dispatch(checkIfOrderIsArchived(orderId)),
            reDeliverImages: (orderId: number) => dispatch(actions.reDeliverImages(orderId)),
            clearState: () => dispatch(actions.clearState()),
            getContentProvider: (orderId: number) => dispatch(actions.getContentProvider(orderId)),
            listImages: (orderId: number, value: number) =>
                dispatch(actions.listImages(orderId, value)),
            getDeliveryStatusForOrder: (orderId: number) =>
                dispatch(actions.getDeliveryStatusForOrder(orderId)),
            getVitecBrokerSystemDeliveryInfo: (orderId: number) =>
                dispatch(actions.getVitecBrokerSystemDeliveryInfo(orderId)),
            resetDelivery: (orderId: number) => dispatch(actions.resetDelivery(orderId)),
            resetRejection: (orderId: number) => dispatch(actions.resetRejection(orderId))
        }
    };
}

function mapStateToProps(state: any, ownProps: any) {
	return {
		numberOfImages: state.imageProcessing.numberOfImages,
		extraImages: state.imageProcessing.edited.extraSelected,
		orderRows: state.imageProcessing.edited.list,
		imageProcessingComments: state.imageProcessing.comments,
		user: state.user,
		photoStatus: state.imageProcessing.photoStatus,
		photoIsArchived: state.orders.photoIsArchived,
		archivedInfo: selectArchivedInfo(state),
		anyFailedUploadedImages: state.imageProcessing.unedited.list.some(
			(x) => x.failedUploads.length > 0
		),
		editedList: state.imageProcessing.edited.list,
		contentProvider: state.imageProcessing.contentProvider,
		orderApiUrl: state.imageProcessing.orderApiUrl,
		contentProviderValue: state.imageProcessing.contentProviderValue,
        site: state.site
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageProcessingPage);
